import { render } from "./title.vue?vue&type=template&id=5eeb1621"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=5eeb1621&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/text/title.vue'],['render',render],['__file',"title.vue"]])

export default __exports__